import { Serialiser } from "./types";

export const literalListSerialiser = <T extends string>(
  permitted: readonly T[]
): Serialiser<T[], never> => {
  const permittedSet = new Set<string>(permitted);

  return {
    format: (value) => value.map(encodeURIComponent).join(","),
    parse: (text) => {
      if (text.length === 0) {
        return { valid: true, value: [] };
      }
      const seen = new Set<T>();
      for (const token of text.split(",")) {
        let decoded: string;
        try {
          decoded = decodeURIComponent(token);
        } catch {
          continue;
        }
        if (permittedSet.has(decoded)) {
          seen.add(decoded as T);
        }
      }
      return { valid: true, value: [...seen] };
    },
  };
};
